/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { masterAPI, proyekAPI, gudangAPI } from '../services/api';
import { LoadingSpinner, ErrorBox, EmptyState } from '../components/LoadingSpinner';
import ImportExcel from '../components/ImportExcel';

function formatRp(n) { return 'Rp ' + Number(n||0).toLocaleString('id-ID'); }

const inputStyle = {
  padding:'8px 10px', border:'1.5px solid #ddd', borderRadius:'8px',
  fontSize:'13px', color:'#333', background:'#fafafa',
  outline:'none', width:'100%', fontFamily:'inherit', boxSizing:'border-box'
};

function Modal({ show, onClose, title, children, footer, size='500px' }) {
  if (!show) return null;
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:999, padding:'20px' }}>
      <div style={{ background:'white', borderRadius:'16px', width:'100%', maxWidth:size, maxHeight:'90vh', display:'flex', flexDirection:'column', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'16px 24px', borderBottom:'1px solid #f0f4f8' }}>
          <h3 style={{ fontSize:'15px', color:'#1a3a5c', margin:0 }}>{title}</h3>
          <button onClick={onClose} style={{ background:'none', border:'none', fontSize:'20px', cursor:'pointer', color:'#888' }}>✕</button>
        </div>
        <div style={{ padding:'20px', overflowY:'auto', flex:1, display:'flex', flexDirection:'column', gap:'14px' }}>{children}</div>
        {footer && <div style={{ padding:'14px 20px', borderTop:'1px solid #f0f4f8', display:'flex', justifyContent:'flex-end', gap:'10px' }}>{footer}</div>}
      </div>
    </div>
  );
}

function Btn({ onClick, color='biru', children, disabled, size='normal' }) {
  const colors = {
    biru:  { bg:'linear-gradient(135deg,#1a3a5c,#2d6a9f)', txt:'white' },
    hijau: { bg:'linear-gradient(135deg,#1e8449,#27ae60)',  txt:'white' },
    merah: { bg:'linear-gradient(135deg,#c0392b,#e74c3c)',  txt:'white' },
    abu:   { bg:'white', txt:'#333', border:'1.5px solid #ddd' },
  };
  const c = colors[color];
  const pad = size==='small' ? '5px 12px' : '9px 16px';
  return (
    <button onClick={onClick} disabled={disabled} style={{ padding:pad, background:c.bg, color:c.txt, border:c.border||'none', borderRadius:'8px', fontSize: size==='small'?'12px':'13px', fontWeight:'600', cursor:disabled?'not-allowed':'pointer', opacity:disabled?0.6:1, whiteSpace:'nowrap' }}>
      {children}
    </button>
  );
}

function FG({ label, required, children, span }) {
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'6px', gridColumn: span?'1/-1':'auto' }}>
      <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>{label} {required && <span style={{ color:'#e74c3c' }}>*</span>}</label>
      {children}
    </div>
  );
}

// ============================================
// TAB: DAFTAR PROYEK
// ============================================
function TabProyek() {
  const [list, setList]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [sortBy, setSortBy] = useState('kode'); // kode / nama / klien
  const [showForm, setShowForm] = useState(false);
  const [editData, setEditData] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [confirmHapus, setConfirmHapus] = useState(null);
  const [form, setForm] = useState({ kode:'', nama:'', lokasi:'', nilai_kontrak:'', no_kontrak:'', tgl_mulai:'', tgl_selesai:'', klien:'', pic:'', deskripsi:'', status:'aktif' });

  useEffect(() => { fetchData(); }, []);

  async function fetchData() {
    setLoading(true);
    const r = await proyekAPI.getAll();
    if (r.ok) setList(r.data.data);
    setLoading(false);
  }

  function bukaTambah() {
    setEditData(null);
    setForm({ kode:'', nama:'', lokasi:'', nilai_kontrak:'', no_kontrak:'', tgl_mulai:'', tgl_selesai:'', klien:'', pic:'', deskripsi:'', status:'berjalan' });
    setShowForm(true);
  }

  function bukaEdit(p) {
    setEditData(p);
    setForm({
      kode: p.kode, nama: p.nama, lokasi: p.lokasi||'', nilai_kontrak: String(p.nilai_kontrak||''),
      no_kontrak: p.no_kontrak||'',
      tgl_mulai: p.tgl_mulai?.split('T')[0]||'', tgl_selesai: p.tgl_selesai?.split('T')[0]||'',
      klien: p.klien||'', pic: p.pic||'', deskripsi: p.deskripsi||'', status: p.status||'sedang berjalan'
    });
    setShowForm(true);
  }

  async function submitForm() {
    if (!form.nama) { alert('⚠️ Nama proyek wajib diisi!'); return; }
    if (!editData && !form.kode) { alert('⚠️ Kode proyek wajib diisi!'); return; }
    setSubmitting(true);
    try {
      const result = editData
        ? await proyekAPI.update(editData.id, { ...form, nilai_kontrak: Number(form.nilai_kontrak||0) })
        : await proyekAPI.create({ ...form, nilai_kontrak: Number(form.nilai_kontrak||0) });
      if (result.ok) {
        alert(`✅ Proyek berhasil ${editData?'diperbarui':'ditambahkan'}`);
        setShowForm(false);
        fetchData();
      } else alert(`❌ ${result.data.message}`);
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  async function konfirmasiHapus() {
    setSubmitting(true);
    try {
      const result = await proyekAPI.delete(confirmHapus.id);
      if (result.ok) { alert('✅ Proyek berhasil dihapus'); setConfirmHapus(null); fetchData(); }
      else { alert(`❌ ${result.data.message}`); setConfirmHapus(null); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  const filtered = list.filter(p =>
    !search ||
    p.nama.toLowerCase().includes(search.toLowerCase()) ||
    p.kode.toLowerCase().includes(search.toLowerCase()) ||
    (p.klien||'').toLowerCase().includes(search.toLowerCase())
  );

  const sorted = [...filtered].sort((a, b) => {
    if (sortBy === 'kode')  return a.kode.localeCompare(b.kode, 'id', { numeric:true });
    if (sortBy === 'nama')  return a.nama.localeCompare(b.nama, 'id');
    if (sortBy === 'klien') return (a.klien||'').localeCompare(b.klien||'', 'id');
    return 0;
  });

  function statusBadgeProyek(status) {
    if (status === 'selesai') return { bg:'#eaf0fb', color:'#2980b9', label:'✅ Selesai' };
    if (status === 'nonaktif') return { bg:'#f0f4f8', color:'#888', label:'⚫ Nonaktif' };
    return { bg:'#eafaf1', color:'#27ae60', label:'🟢 Sedang Berjalan' };
  }

  if (loading) return <LoadingSpinner pesan="Memuat daftar proyek..." />;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'10px' }}>
        <div style={{ display:'flex', gap:'10px' }}>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Cari kode/nama/klien..." style={{ ...inputStyle, maxWidth:'260px' }} />
          <select value={sortBy} onChange={e=>setSortBy(e.target.value)} style={{ ...inputStyle, maxWidth:'170px' }}>
            <option value="kode">↕️ Urutkan: Kode</option>
            <option value="nama">↕️ Urutkan: Nama (A-Z)</option>
            <option value="klien">↕️ Urutkan: Klien</option>
          </select>
        </div>
        <div style={{ display:'flex', gap:'10px', alignItems:'center' }}>
          <span style={{ fontSize:'12px', color:'#888' }}>Total: <strong>{list.length}</strong> proyek</span>
          <ImportExcel
            label="📥 Import Excel"
            columnMap={[
              { excelHeader:'Kode',          field:'kode',          required:true },
              { excelHeader:'Nama',          field:'nama',          required:true },
              { excelHeader:'Lokasi',        field:'lokasi' },
              { excelHeader:'Klien',         field:'klien' },
              { excelHeader:'PIC',           field:'pic' },
              { excelHeader:'No Kontrak',    field:'no_kontrak' },
              { excelHeader:'Nilai Kontrak', field:'nilai_kontrak' },
            ]}
            templateNote="Kolom Excel: Kode, Nama (wajib), Lokasi, Klien, PIC, No Kontrak, Nilai Kontrak (opsional)."
            onImport={async (items) => { const r = await proyekAPI.bulkImport(items); if (r.ok) fetchData(); return r; }}
          />
          <Btn onClick={bukaTambah}>+ Tambah Proyek Baru</Btn>
        </div>
      </div>

      {sorted.length === 0 ? (
        <EmptyState icon="📁" judul="Belum ada proyek" sub="Klik '+ Tambah Proyek Baru' untuk menambahkan" />
      ) : (
        <div style={{ background:'white', borderRadius:'12px', overflow:'hidden', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
          <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead><tr style={{ borderBottom:'2px solid #f0f4f8' }}>
                {['Kode','Nama Proyek','No. Kontrak','Lokasi','Klien','PIC','Nilai Kontrak','Status','Aksi'].map(h=>(
                  <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'10px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {sorted.map(p=>(
                  <tr key={p.id} style={{ borderBottom:'1px solid #f5f7fa', opacity: p.status==='aktif'?1:0.55 }}>
                    <td style={{ padding:'12px', fontSize:'12px', fontWeight:'700' }}>{p.kode}</td>
                    <td style={{ padding:'12px', fontSize:'13px', fontWeight:'500' }}>{p.nama}</td>
                    <td style={{ padding:'12px', fontSize:'12px', color:'#2d6a9f' }}>{p.no_kontrak||'-'}</td>
                    <td style={{ padding:'12px', fontSize:'12px', color:'#666' }}>{p.lokasi||'-'}</td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>{p.klien||'-'}</td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>{p.pic||'-'}</td>
                    <td style={{ padding:'12px', fontSize:'13px', fontWeight:'600' }}>{formatRp(p.nilai_kontrak)}</td>
                    <td style={{ padding:'12px' }}>
                      <span style={{ padding:'3px 10px', borderRadius:'99px', fontSize:'11px', fontWeight:'700', background: p.status==='aktif'?'#eafaf1':'#f0f4f8', color: p.status==='aktif'?'#27ae60':'#888' }}>
                        {p.status==='aktif'?'🟢 Aktif':'⚫ Nonaktif'}
                      </span>
                    </td>
                    <td style={{ padding:'12px' }}>
                      {(() => { const sc = statusBadgeProyek(p.status); return (
                        <span style={{ padding:'3px 10px', borderRadius:'99px', fontSize:'11px', fontWeight:'700', background:sc.bg, color:sc.color, whiteSpace:'nowrap' }}>
                          {sc.label}
                        </span>
                      ); })()}
                    </td>
                    <td style={{ padding:'12px' }}>
                      <div style={{ display:'flex', gap:'6px' }}>
                        <Btn size="small" color="abu" onClick={()=>bukaEdit(p)}>✏️ Edit</Btn>
                        <Btn size="small" color="merah" onClick={()=>setConfirmHapus(p)}>🗑️ Hapus</Btn>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <Modal show={showForm} onClose={()=>setShowForm(false)} title={editData ? `✏️ Edit Proyek — ${editData.kode}` : '📁 Tambah Proyek Baru'} size="620px"
        footer={<><Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn><Btn onClick={submitForm} disabled={submitting}>{submitting?'⏳...':'✅ Simpan'}</Btn></>}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' }}>
          <FG label="Kode Proyek" required>
            <input value={form.kode} onChange={e=>setForm({...form,kode:e.target.value})} disabled={!!editData} placeholder="PRJ-005" style={{ ...inputStyle, background: editData?'#f0f4f8':'#fafafa' }} />
          </FG>
          <FG label="Status">
            <select value={form.status} onChange={e=>setForm({...form,status:e.target.value})} style={inputStyle}>
              <option value="berjalan">🟢 Sedang Berjalan</option>
              <option value="selesai">✅ Selesai</option>
            </select>
          </FG>
          <FG label="Nama Proyek" required span><input value={form.nama} onChange={e=>setForm({...form,nama:e.target.value})} style={inputStyle} /></FG>
          <FG label="No. Kontrak"><input value={form.no_kontrak} onChange={e=>setForm({...form,no_kontrak:e.target.value})} placeholder="No. kontrak kerja" style={inputStyle} /></FG>
          <FG label="Lokasi"><input value={form.lokasi} onChange={e=>setForm({...form,lokasi:e.target.value})} style={inputStyle} /></FG>
          <FG label="Nilai Kontrak (Rp)"><input type="number" value={form.nilai_kontrak} onChange={e=>setForm({...form,nilai_kontrak:e.target.value})} style={inputStyle} /></FG>
          <FG label="Klien"><input value={form.klien} onChange={e=>setForm({...form,klien:e.target.value})} style={inputStyle} /></FG>
          <FG label="PIC"><input value={form.pic} onChange={e=>setForm({...form,pic:e.target.value})} style={inputStyle} /></FG>
          <FG label="Tanggal Mulai"><input type="date" value={form.tgl_mulai} onChange={e=>setForm({...form,tgl_mulai:e.target.value})} style={inputStyle} /></FG>
          <FG label="Tanggal Selesai"><input type="date" value={form.tgl_selesai} onChange={e=>setForm({...form,tgl_selesai:e.target.value})} style={inputStyle} /></FG>
          <FG label="Deskripsi" span><textarea value={form.deskripsi} onChange={e=>setForm({...form,deskripsi:e.target.value})} rows="3" style={{ ...inputStyle, resize:'vertical' }} /></FG>
        </div>
      </Modal>
      <Modal show={!!confirmHapus} onClose={()=>setConfirmHapus(null)} title="⚠️ Konfirmasi Hapus Proyek" size="420px"
        footer={<><Btn color="abu" onClick={()=>setConfirmHapus(null)} disabled={submitting}>Batal</Btn><Btn color="merah" onClick={konfirmasiHapus} disabled={submitting}>{submitting?'⏳...':'🗑️ Ya, Hapus'}</Btn></>}>
        <p style={{ fontSize:'13px', color:'#333' }}>Yakin ingin menghapus proyek <strong>{confirmHapus?.nama}</strong> ({confirmHapus?.kode}) secara permanen?</p>
        <div style={{ background:'#fef5e7', padding:'12px', borderRadius:'8px', fontSize:'12px', color:'#8a5a00' }}>
          ⚠️ Jika proyek memiliki data terkait (RAB, PO, transaksi), penghapusan akan gagal dan Anda perlu mengubah status ke <strong>Selesai</strong> sebagai gantinya.
        </div>
      </Modal>
    </div>
  );
}

// ============================================
// TAB: DAFTAR SUPPLIER
// ============================================
function TabSupplier() {
  const [list, setList]         = useState([]);
  const [loading, setLoading]   = useState(true);
  const [search, setSearch]     = useState('');
  const [sortBy, setSortBy]     = useState('kode'); // kode / nama / kategori
  const [showForm, setShowForm] = useState(false);
  const [editData, setEditData] = useState(null);
  const [confirmHapus, setConfirmHapus] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({ kode:'', nama:'', kategori:'', alamat:'', pic:'', kontak:'', email:'' });

  useEffect(() => { fetchData(); }, []);

  async function fetchData() {
    setLoading(true);
    const r = await masterAPI.getAllVendor();
    if (r.ok) setList(r.data.data);
    setLoading(false);
  }

  function bukaTambah() { setEditData(null); setForm({ kode:'', nama:'', kategori:'', alamat:'', pic:'', kontak:'', email:'' }); setShowForm(true); }
  function bukaEdit(v) { setEditData(v); setForm({ kode:v.kode, nama:v.nama, kategori:v.kategori||'', alamat:v.alamat||'', pic:v.pic||'', kontak:v.kontak||'', email:v.email||'' }); setShowForm(true); }

  async function submitForm() {
    if (!form.kode || !form.nama) { alert('⚠️ Kode dan nama wajib diisi!'); return; }
    setSubmitting(true);
    try {
      const result = editData
        ? await masterAPI.updateVendor(editData.id, { ...form, is_active:true })
        : await masterAPI.createVendor(form);
      if (result.ok) { alert(`✅ ${result.data.message}`); setShowForm(false); fetchData(); }
      else alert(`❌ ${result.data.message}`);
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  async function konfirmasiHapus() {
    setSubmitting(true);
    try {
      const result = await masterAPI.deleteVendor(confirmHapus.id);
      if (result.ok) { alert('✅ Supplier berhasil dihapus'); setConfirmHapus(null); fetchData(); }
      else alert(`❌ ${result.data.message}`);
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

    const filtered = list.filter(v => !search || v.nama.toLowerCase().includes(search.toLowerCase()) || v.kode.toLowerCase().includes(search.toLowerCase()));

    const sorted = [...filtered].sort((a, b) => {
      if (sortBy === 'kode')     return a.kode.localeCompare(b.kode, 'id', { numeric:true });
      if (sortBy === 'nama')     return a.nama.localeCompare(b.nama, 'id');
      if (sortBy === 'kategori') return (a.kategori||'').localeCompare(b.kategori||'', 'id') || a.nama.localeCompare(b.nama, 'id');
      return 0;
    });

  if (loading) return <LoadingSpinner pesan="Memuat daftar supplier..." />;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'10px' }}>
        <div style={{ display:'flex', gap:'10px' }}>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Cari kode/nama supplier..." style={{ ...inputStyle, maxWidth:'260px' }} />
          <select value={sortBy} onChange={e=>setSortBy(e.target.value)} style={{ ...inputStyle, maxWidth:'170px' }}>
            <option value="kode">↕️ Urutkan: Kode</option>
            <option value="nama">↕️ Urutkan: Nama (A-Z)</option>
            <option value="kategori">↕️ Urutkan: Kategori</option>
          </select>
        </div>
        <div style={{ display:'flex', gap:'10px' }}>
          <ImportExcel
            label="📥 Import Excel"
            columnMap={[
              { excelHeader:'Kode',     field:'kode',   required:true },
              { excelHeader:'Nama',     field:'nama',   required:true },
              { excelHeader:'Kategori', field:'kategori' },
              { excelHeader:'Alamat',   field:'alamat' },
              { excelHeader:'PIC',      field:'pic' },
              { excelHeader:'Kontak',   field:'kontak' },
              { excelHeader:'Email',    field:'email' },
            ]}
            templateNote="Kolom Excel: Kode, Nama (wajib), Kategori, Alamat, PIC, Kontak, Email (opsional)."
            onImport={async (items) => { const r = await masterAPI.bulkImportVendor(items); if (r.ok) fetchData(); return r; }}
          />
          <Btn onClick={bukaTambah}>+ Tambah Supplier</Btn>
        </div>
      </div>

      {sorted.length === 0 ? (
        <EmptyState icon="🏢" judul="Belum ada supplier" sub="Klik '+ Tambah Supplier' untuk menambahkan" />
      ) : (
        <div style={{ background:'white', borderRadius:'12px', overflow:'hidden', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead><tr style={{ borderBottom:'2px solid #f0f4f8' }}>
              {['Kode','Nama Supplier','Kategori','PIC','Kontak','Aksi'].map(h=>(
                <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'10px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {sorted.map(v=>(
                <tr key={v.id} style={{ borderBottom:'1px solid #f5f7fa' }}>
                  <td style={{ padding:'12px', fontSize:'12px', fontWeight:'700' }}>{v.kode}</td>
                  <td style={{ padding:'12px', fontSize:'13px', fontWeight:'500' }}>{v.nama}</td>
                  <td style={{ padding:'12px', fontSize:'12px', color:'#666' }}>{v.kategori||'-'}</td>
                  <td style={{ padding:'12px', fontSize:'12px' }}>{v.pic||'-'}</td>
                  <td style={{ padding:'12px', fontSize:'12px' }}>{v.kontak||'-'}</td>
                  <td style={{ padding:'12px' }}>
                    <div style={{ display:'flex', gap:'6px' }}>
                      <Btn size="small" color="abu" onClick={()=>bukaEdit(v)}>✏️ Edit</Btn>
                      <Btn size="small" color="merah" onClick={()=>setConfirmHapus(v)}>🗑️ Hapus</Btn>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <Modal show={showForm} onClose={()=>setShowForm(false)} title={editData?`✏️ Edit Supplier`:`🏢 Tambah Supplier`}
        footer={<><Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn><Btn onClick={submitForm} disabled={submitting}>{submitting?'⏳...':'✅ Simpan'}</Btn></>}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' }}>
          <FG label="Kode Supplier" required><input value={form.kode} onChange={e=>setForm({...form,kode:e.target.value})} disabled={!!editData} placeholder="VND-006" style={{ ...inputStyle, background: editData?'#f0f4f8':'#fafafa' }} /></FG>
          <FG label="Kategori"><input value={form.kategori} onChange={e=>setForm({...form,kategori:e.target.value})} placeholder="Material Bangunan" style={inputStyle} /></FG>
          <FG label="Nama Supplier" required span><input value={form.nama} onChange={e=>setForm({...form,nama:e.target.value})} placeholder="Nama perusahaan" style={inputStyle} /></FG>
          <FG label="Alamat" span><input value={form.alamat} onChange={e=>setForm({...form,alamat:e.target.value})} placeholder="Alamat lengkap" style={inputStyle} /></FG>
          <FG label="PIC"><input value={form.pic} onChange={e=>setForm({...form,pic:e.target.value})} placeholder="Nama kontak" style={inputStyle} /></FG>
          <FG label="No. Kontak"><input value={form.kontak} onChange={e=>setForm({...form,kontak:e.target.value})} placeholder="08xx..." style={inputStyle} /></FG>
          <FG label="Email" span><input value={form.email} onChange={e=>setForm({...form,email:e.target.value})} placeholder="email@supplier.com" style={inputStyle} /></FG>
        </div>
      </Modal>

      <Modal show={!!confirmHapus} onClose={()=>setConfirmHapus(null)} title="⚠️ Konfirmasi Hapus Supplier" size="420px"
        footer={<><Btn color="abu" onClick={()=>setConfirmHapus(null)} disabled={submitting}>Batal</Btn><Btn color="merah" onClick={konfirmasiHapus} disabled={submitting}>{submitting?'⏳...':'🗑️ Ya, Hapus'}</Btn></>}>
        <p style={{ fontSize:'13px', color:'#333' }}>Yakin ingin menghapus supplier <strong>{confirmHapus?.nama}</strong> ({confirmHapus?.kode})?</p>
      </Modal>
    </div>
  );
}

// ============================================
// TAB: DAFTAR MATERIAL
// ============================================
function TabMaterial() {
  const [list, setList]         = useState([]);
  const [loading, setLoading]   = useState(true);
  const [search, setSearch]     = useState('');
  const [sortBy, setSortBy] = useState('kode'); // kode / nama / kategori
  const [showForm, setShowForm] = useState(false);
  const [editData, setEditData] = useState(null);
  const [confirmHapus, setConfirmHapus] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({ kode:'', nama:'', kategori:'', satuan:'', stok_minimum:'' });

  useEffect(() => { fetchData(); }, []);

  async function fetchData() {
    setLoading(true);
    const r = await gudangAPI.getAllBarang();
    if (r.ok) setList(r.data.data);
    setLoading(false);
  }

  function bukaTambah() { setEditData(null); setForm({ kode:'', nama:'', kategori:'', satuan:'', stok_minimum:'' }); setShowForm(true); }
  function bukaEdit(b) { setEditData(b); setForm({ kode:b.kode, nama:b.nama, kategori:b.kategori||'', satuan:b.satuan||'', stok_minimum:String(b.stok_minimum||'') }); setShowForm(true); }

  async function submitForm() {
    if (!form.kode || !form.nama) { alert('⚠️ Kode dan nama wajib diisi!'); return; }
    setSubmitting(true);
    try {
      const result = editData
        ? await gudangAPI.updateBarang(editData.id, form)
        : await gudangAPI.createBarang(form);
      if (result.ok) { alert(`✅ ${result.data.message}`); setShowForm(false); fetchData(); }
      else alert(`❌ ${result.data.message}`);
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  async function konfirmasiHapus() {
    setSubmitting(true);
    try {
      const result = await gudangAPI.deleteBarang(confirmHapus.id);
      if (result.ok) { alert('✅ Material berhasil dihapus'); setConfirmHapus(null); fetchData(); }
      else alert(`❌ ${result.data.message}`);
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  const filtered = list.filter(b => !search || b.nama.toLowerCase().includes(search.toLowerCase()) || b.kode.toLowerCase().includes(search.toLowerCase()));

  // Urutkan sesuai pilihan
  const sorted = [...filtered].sort((a, b) => {
    if (sortBy === 'kode')     return a.kode.localeCompare(b.kode, 'id', { numeric:true });
    if (sortBy === 'nama')     return a.nama.localeCompare(b.nama, 'id');
    if (sortBy === 'kategori') return (a.kategori||'Lainnya').localeCompare(b.kategori||'Lainnya', 'id') || a.nama.localeCompare(b.nama, 'id');
    return 0;
  });

  const byKategori = {};
  filtered.forEach(b => { const k = b.kategori||'Lainnya'; if(!byKategori[k]) byKategori[k]=[]; byKategori[k].push(b); });

  if (loading) return <LoadingSpinner pesan="Memuat daftar material..." />;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'10px' }}>
        <div style={{ display:'flex', gap:'10px' }}>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Cari kode/nama material..." style={{ ...inputStyle, maxWidth:'260px' }} />
          <select value={sortBy} onChange={e=>setSortBy(e.target.value)} style={{ ...inputStyle, maxWidth:'170px' }}>
            <option value="kode">↕️ Urutkan: Kode</option>
            <option value="nama">↕️ Urutkan: Nama (A-Z)</option>
            <option value="kategori">↕️ Urutkan: Kategori</option>
          </select>
        </div>
        <div style={{ display:'flex', gap:'10px', alignItems:'center' }}>
          <span style={{ fontSize:'12px', color:'#888' }}>Total: <strong>{list.length}</strong> material</span>
          <ImportExcel
            label="📥 Import Excel"
            columnMap={[
              { excelHeader:'Kode',    field:'kode',   required:true },
              { excelHeader:'Nama',    field:'nama',   required:true },
              { excelHeader:'Kategori',field:'kategori' },
              { excelHeader:'Satuan',  field:'satuan' },
            ]}
            templateNote="Kolom Excel: Kode, Nama (wajib), Kategori, Satuan (opsional)."
            onImport={async (items) => { const r = await gudangAPI.bulkImportBarang(items); if (r.ok) fetchData(); return r; }}
          />
          <Btn onClick={bukaTambah}>+ Tambah Material</Btn>
        </div>
      </div>

      {filtered.length === 0 ? (
        <EmptyState icon="📦" judul="Belum ada material" sub="Klik '+ Tambah Material' untuk menambahkan" />
      ) : (
        <div style={{ background:'white', borderRadius:'12px', overflow:'hidden', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead><tr style={{ background:'#f78fb3' }}>
              {['Kode','Nama','Kategori','Satuan','Stok Min','Aksi'].map(h=>(
                <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'white', padding:'10px 12px', textTransform:'uppercase' }}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {sortBy === 'kategori' ? (
                Object.entries(byKategori).map(([kategori, items])=>(
                  <React.Fragment key={kategori}>
                    <tr style={{ background:'#f8f0f5' }}>
                      <td colSpan={6} style={{ padding:'8px 12px', fontSize:'11px', fontWeight:'700', color:'#c2185b' }}>{kategori}</td>
                    </tr>
                    {items.map(b=>(
                      <tr key={b.id} style={{ borderBottom:'1px solid #f5f7fa' }}>
                        <td style={{ padding:'10px 12px', fontSize:'12px', fontWeight:'700', color:'#1a3a5c' }}>{b.kode}</td>
                        <td style={{ padding:'10px 12px', fontSize:'13px' }}>{b.nama}</td>
                        <td style={{ padding:'10px 12px', fontSize:'12px', color:'#666' }}>{b.kategori||'-'}</td>
                        <td style={{ padding:'10px 12px', fontSize:'12px' }}>{b.satuan}</td>
                        <td style={{ padding:'10px 12px', fontSize:'12px', color:'#888' }}>{b.stok_minimum}</td>
                        <td style={{ padding:'10px 12px' }}>
                          <div style={{ display:'flex', gap:'6px' }}>
                            <Btn size="small" color="abu" onClick={()=>bukaEdit(b)}>✏️</Btn>
                            <Btn size="small" color="merah" onClick={()=>setConfirmHapus(b)}>🗑️</Btn>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))
              ) : (
                sorted.map(b=>(
                  <tr key={b.id} style={{ borderBottom:'1px solid #f5f7fa' }}>
                    <td style={{ padding:'10px 12px', fontSize:'12px', fontWeight:'700', color:'#1a3a5c' }}>{b.kode}</td>
                    <td style={{ padding:'10px 12px', fontSize:'13px' }}>{b.nama}</td>
                    <td style={{ padding:'10px 12px', fontSize:'12px', color:'#666' }}>{b.kategori||'-'}</td>
                    <td style={{ padding:'10px 12px', fontSize:'12px' }}>{b.satuan}</td>
                    <td style={{ padding:'10px 12px', fontSize:'12px', color:'#888' }}>{b.stok_minimum}</td>
                    <td style={{ padding:'10px 12px' }}>
                      <div style={{ display:'flex', gap:'6px' }}>
                        <Btn size="small" color="abu" onClick={()=>bukaEdit(b)}>✏️</Btn>
                        <Btn size="small" color="merah" onClick={()=>setConfirmHapus(b)}>🗑️</Btn>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      <Modal show={showForm} onClose={()=>setShowForm(false)} title={editData?'✏️ Edit Material':'📦 Tambah Material Baru'}
        footer={<><Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn><Btn onClick={submitForm} disabled={submitting}>{submitting?'⏳...':'✅ Simpan'}</Btn></>}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' }}>
          <FG label="Kode Material" required><input value={form.kode} onChange={e=>setForm({...form,kode:e.target.value})} disabled={!!editData} placeholder="A100, BRG-010" style={{ ...inputStyle, background: editData?'#f0f4f8':'#fafafa' }} /></FG>
          <FG label="Satuan"><input value={form.satuan} onChange={e=>setForm({...form,satuan:e.target.value})} placeholder="lbr, btg, m³" style={inputStyle} /></FG>
          <FG label="Nama Material" required span><input value={form.nama} onChange={e=>setForm({...form,nama:e.target.value})} placeholder="Nama material" style={inputStyle} /></FG>
          <FG label="Kategori"><input value={form.kategori} onChange={e=>setForm({...form,kategori:e.target.value})} placeholder="Besi & Baja, dll" style={inputStyle} /></FG>
          <FG label="Stok Minimum"><input type="number" value={form.stok_minimum} onChange={e=>setForm({...form,stok_minimum:e.target.value})} placeholder="0" style={inputStyle} /></FG>
        </div>
      </Modal>

      <Modal show={!!confirmHapus} onClose={()=>setConfirmHapus(null)} title="⚠️ Konfirmasi Hapus Material" size="420px"
        footer={<><Btn color="abu" onClick={()=>setConfirmHapus(null)} disabled={submitting}>Batal</Btn><Btn color="merah" onClick={konfirmasiHapus} disabled={submitting}>{submitting?'⏳...':'🗑️ Ya, Hapus'}</Btn></>}>
        <p style={{ fontSize:'13px', color:'#333' }}>Yakin ingin menghapus material <strong>{confirmHapus?.nama}</strong> ({confirmHapus?.kode})?</p>
      </Modal>
    </div>
  );
}

// ============================================
// TAB: DAFTAR CLIENT
// ============================================
function TabClient() {
  const [list, setList]         = useState([]);
  const [loading, setLoading]   = useState(true);
  const [search, setSearch]     = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editData, setEditData] = useState(null);
  const [confirmHapus, setConfirmHapus] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({ kode:'', nama:'', jenis:'swasta', alamat:'', pic:'', kontak:'', email:'' });

  useEffect(() => { fetchData(); }, []);

  async function fetchData() {
    setLoading(true);
    const r = await masterAPI.getAllKlien();
    if (r.ok) setList(r.data.data);
    setLoading(false);
  }

  function bukaTambah() { setEditData(null); setForm({ kode:'', nama:'', jenis:'swasta', alamat:'', pic:'', kontak:'', email:'' }); setShowForm(true); }
  function bukaEdit(k) { setEditData(k); setForm({ kode:k.kode, nama:k.nama, jenis:k.jenis||'swasta', alamat:k.alamat||'', pic:k.pic||'', kontak:k.kontak||'', email:k.email||'' }); setShowForm(true); }

  async function submitForm() {
    if (!form.kode || !form.nama) { alert('⚠️ Kode dan nama wajib diisi!'); return; }
    setSubmitting(true);
    try {
      const result = editData
        ? await masterAPI.updateKlien(editData.id, { ...form, is_active:true })
        : await masterAPI.createKlien(form);
      if (result.ok) { alert(`✅ ${result.data.message}`); setShowForm(false); fetchData(); }
      else alert(`❌ ${result.data.message}`);
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  async function konfirmasiHapus() {
    setSubmitting(true);
    try {
      const result = await masterAPI.deleteKlien(confirmHapus.id);
      if (result.ok) { alert('✅ Klien berhasil dihapus'); setConfirmHapus(null); fetchData(); }
      else alert(`❌ ${result.data.message}`);
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  const jenisLabel = (j) => j==='pemerintah'?'🏛️ Pemerintah':j==='bumn'?'🏢 BUMN':'🏪 Swasta';
  const filtered = list.filter(k => !search || k.nama.toLowerCase().includes(search.toLowerCase()) || k.kode.toLowerCase().includes(search.toLowerCase()));

  if (loading) return <LoadingSpinner pesan="Memuat daftar klien..." />;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Cari kode/nama klien..." style={{ ...inputStyle, maxWidth:'280px' }} />
        <div style={{ display:'flex', gap:'10px' }}>
          <ImportExcel
            label="📥 Import Excel"
            columnMap={[
              { excelHeader:'Kode',   field:'kode',   required:true },
              { excelHeader:'Nama',   field:'nama',   required:true },
              { excelHeader:'Jenis',  field:'jenis' },
              { excelHeader:'Alamat', field:'alamat' },
              { excelHeader:'PIC',    field:'pic' },
              { excelHeader:'Kontak', field:'kontak' },
              { excelHeader:'Email',  field:'email' },
            ]}
            templateNote="Kolom Excel: Kode, Nama (wajib), Jenis (swasta/pemerintah/bumn), Alamat, PIC, Kontak, Email (opsional)."
            onImport={async (items) => { const r = await masterAPI.bulkImportKlien(items); if (r.ok) fetchData(); return r; }}
          />
          <Btn onClick={bukaTambah}>+ Tambah Klien</Btn>
        </div>
      </div>

      {filtered.length === 0 ? (
        <EmptyState icon="🤝" judul="Belum ada klien" sub="Klik '+ Tambah Klien' untuk menambahkan" />
      ) : (
        <div style={{ background:'white', borderRadius:'12px', overflow:'hidden', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead><tr style={{ borderBottom:'2px solid #f0f4f8' }}>
              {['Kode','Nama Klien','Jenis','PIC','Kontak','Aksi'].map(h=>(
                <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'10px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {filtered.map(k=>(
                <tr key={k.id} style={{ borderBottom:'1px solid #f5f7fa' }}>
                  <td style={{ padding:'12px', fontSize:'12px', fontWeight:'700' }}>{k.kode}</td>
                  <td style={{ padding:'12px', fontSize:'13px', fontWeight:'500' }}>{k.nama}</td>
                  <td style={{ padding:'12px', fontSize:'12px' }}>{jenisLabel(k.jenis)}</td>
                  <td style={{ padding:'12px', fontSize:'12px' }}>{k.pic||'-'}</td>
                  <td style={{ padding:'12px', fontSize:'12px' }}>{k.kontak||'-'}</td>
                  <td style={{ padding:'12px' }}>
                    <div style={{ display:'flex', gap:'6px' }}>
                      <Btn size="small" color="abu" onClick={()=>bukaEdit(k)}>✏️ Edit</Btn>
                      <Btn size="small" color="merah" onClick={()=>setConfirmHapus(k)}>🗑️ Hapus</Btn>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <Modal show={showForm} onClose={()=>setShowForm(false)} title={editData?`✏️ Edit Klien`:`🤝 Tambah Klien`}
        footer={<><Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn><Btn onClick={submitForm} disabled={submitting}>{submitting?'⏳...':'✅ Simpan'}</Btn></>}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' }}>
          <FG label="Kode Klien" required><input value={form.kode} onChange={e=>setForm({...form,kode:e.target.value})} disabled={!!editData} placeholder="CLI-005" style={{ ...inputStyle, background: editData?'#f0f4f8':'#fafafa' }} /></FG>
          <FG label="Jenis">
            <select value={form.jenis} onChange={e=>setForm({...form,jenis:e.target.value})} style={inputStyle}>
              <option value="swasta">🏪 Swasta</option>
              <option value="pemerintah">🏛️ Pemerintah</option>
              <option value="bumn">🏢 BUMN</option>
            </select>
          </FG>
          <FG label="Nama Klien" required span><input value={form.nama} onChange={e=>setForm({...form,nama:e.target.value})} placeholder="Nama perusahaan/instansi" style={inputStyle} /></FG>
          <FG label="Alamat" span><input value={form.alamat} onChange={e=>setForm({...form,alamat:e.target.value})} placeholder="Alamat lengkap" style={inputStyle} /></FG>
          <FG label="PIC"><input value={form.pic} onChange={e=>setForm({...form,pic:e.target.value})} placeholder="Nama kontak" style={inputStyle} /></FG>
          <FG label="No. Kontak"><input value={form.kontak} onChange={e=>setForm({...form,kontak:e.target.value})} placeholder="08xx..." style={inputStyle} /></FG>
          <FG label="Email" span><input value={form.email} onChange={e=>setForm({...form,email:e.target.value})} placeholder="email@klien.com" style={inputStyle} /></FG>
        </div>
      </Modal>

      <Modal show={!!confirmHapus} onClose={()=>setConfirmHapus(null)} title="⚠️ Konfirmasi Hapus Klien" size="420px"
        footer={<><Btn color="abu" onClick={()=>setConfirmHapus(null)} disabled={submitting}>Batal</Btn><Btn color="merah" onClick={konfirmasiHapus} disabled={submitting}>{submitting?'⏳...':'🗑️ Ya, Hapus'}</Btn></>}>
        <p style={{ fontSize:'13px', color:'#333' }}>Yakin ingin menghapus klien <strong>{confirmHapus?.nama}</strong> ({confirmHapus?.kode})?</p>
      </Modal>
    </div>
  );
}

// ============================================
// KOMPONEN UTAMA: MASTER DATA
// ============================================
function MasterData({ user }) {
  const [tabAktif, setTabAktif] = useState('proyek');

  const tabs = [
    { id:'proyek',   label:'📁 Daftar Proyek'   },
    { id:'supplier', label:'🏢 Daftar Supplier' },
    { id:'material', label:'📦 Daftar Material' },
    { id:'client',   label:'🤝 Daftar Client'   },
  ];

  return (
    <div style={{ display:'flex', flexDirection:'column' }}>
      <header style={{ display:'flex', justifyContent:'space-between', alignItems:'center', background:'white', padding:'14px 24px', borderBottom:'1px solid #e8edf2', position:'sticky', top:0, zIndex:10 }}>
        <div>
          <h1 style={{ fontSize:'18px', fontWeight:'700', color:'#1a3a5c', margin:0 }}>Master Data</h1>
          <span style={{ fontSize:'12px', color:'#888' }}>Proyek · Supplier · Material · Client</span>
        </div>
        <div style={{ fontSize:'13px', color:'#666' }}>👤 {user?.nama} — {user?.role}</div>
      </header>

      <div style={{ padding:'24px', display:'flex', flexDirection:'column', gap:'20px' }}>
        <div style={{ display:'flex', gap:'8px', background:'white', padding:'8px', borderRadius:'12px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)', flexWrap:'wrap' }}>
          {tabs.map(t=>(
            <button key={t.id} onClick={()=>setTabAktif(t.id)} style={{
              padding:'10px 20px', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:'pointer',
              background: tabAktif===t.id?'#1a3a5c':'transparent', color: tabAktif===t.id?'white':'#888',
            }}>{t.label}</button>
          ))}
        </div>

        {tabAktif==='proyek'   && <TabProyek />}
        {tabAktif==='supplier' && <TabSupplier />}
        {tabAktif==='material' && <TabMaterial />}
        {tabAktif==='client'   && <TabClient />}
      </div>
    </div>
  );
}

export default MasterData;